<script>
export default {
    data() {
        return {
            itemsOpen: []
        }
    },
    props: {
        items: Array,
        themeDir: String
    },
    methods: {
        toggleQuestion(key) {
            const i = this.itemsOpen.indexOf(key);
            const newArray = [...this.itemsOpen];

            if (i > -1) {
                newArray.splice(i, 1);
                this.itemsOpen = newArray;
            } else {
                this.itemsOpen = [...this.itemsOpen, key];
            }
        },
        expandAll() {
            const newArray = [];
            for (let i = 0; i < this.items.length; i++) {
                newArray[i] = i;
            }
            this.itemsOpen = newArray;
        }
    }
}
</script>

<style>
    details summary::-webkit-details-marker {
        display: none;
    }

    details[open] .expander {
        transform: rotateZ(180deg);
    }
</style>

<template>
    <div class="flex flex-col lg:flex-row justify-between mt-4 xl:items-start w-full" v-if="this.items && this.items.length > 0">
        <div class="w-full">
            <div class="flex flex-wrap justify-end">
                <button class="mb-4" @click="() => {
                                                                     if (this.itemsOpen.length === this.items.length) {
                                                                        this.itemsOpen = [];
                                                                        return;
                                                                     }

                                                                     return expandAll();
                                                                     }"
                                                                     >
                    <div class='flex items-center' v-show="this.itemsOpen.length === items.length">
                        <div class='inline-block mr-3'>Collapse all</div>
                        <img :src="`${themeDir}/images/unfold_less_black_24dp.svg`" alt="Expand less" width="24" height="24">
                    </div>
                    <div class='flex items-center' v-show="this.itemsOpen.length !== items.length">
                        <div class='inline-block mr-3'>Expand all</div>
                        <img :src="`${themeDir}/images/unfold_more_black_24dp.svg`" alt="Expand more" width="24" height="24">
                    </div>
                </button>
            </div>

            <div class="flex flex-wrap justify-start lg:mr-8 w-full">
                <div class="w-full">
                    <details v-for="(item, key) in items" :class="{'border-b': key === items.length - 1, 'border-t border-gray-900 overflow-hidden w-full': true}" :open="this.itemsOpen.indexOf(key) > -1">
                        <summary class="py-6 px-2 text-lg flex flex-nowrap justify-between items-start w-full hover:cursor-pointer">
                            <span class='grow shrink text-left font-bold'>
                                {{ item.Title }}
                            </span>
                            <img :src="`${themeDir}/images/expand_more_black_24dp.svg`" alt="Expand more" width="24" height="24" class="expander ml-auto grow-0 shrink-0 relative w-6">
                        </summary>
                        <div :class="{'px-2 prose prose-2xl content prose-a:text-secondary w-full h-auto pb-6 block': true}" v-html="item.Content"></div>
                    </details>
                </div>
            </div>
        </div>
    </div>
</template>
